// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import './assets/css/bootstrap.min.css'
import './assets/css/font-awesome.min.css'
import './assets/css/reset.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import config from './config'
import router from './router'
import Axios from 'axios'
import Print from 'vue-print-nb'
import moment from 'moment';
import '../static/ueditor/ueditor.config'
import '../static/ueditor/ueditor.all.min'
import '../static/ueditor/lang/zh-cn/zh-cn'
import '../static/ueditor/ueditor.parse.min'
import BaiduMap from 'vue-baidu-map'
import store from './store'//引入store
import SlideVerify from 'vue-monoplasty-slide-verify';



Vue.use(ElementUI)
Vue.use(Print); //注册
Vue.use(BaiduMap, {
  ak: 'G0TZGpi4nwQph4sbefNvLv9NIBsMOS8w'    //这个地方是官方提供的ak密钥
})
Vue.use(SlideVerify);

Vue.prototype.config = config
Vue.prototype.$http = Axios
Vue.config.productionTip = false
Vue.prototype.$moment = moment
// Vue.config.devtools = true


Vue.filter("dateFormat", function(value,format) {
  return value?moment(value).format(format):'';
});

// http请求拦截器
Axios.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})
// http响应拦截器
Axios.interceptors.response.use(data => {// 响应成功关闭loading
  if (data.data.statusCode == 8) {
    router.push('/admin/userlogin')
  } else {
    return data
  }
}, error => {
  return Promise.reject(error)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,//使用store
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js